import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import type { TFunction } from 'i18next';
import type { IBreadcrumbSection, ISection } from '../../../../types';
import IconType from '../../InputComponents/IconType';
import BreadCrumbComponent from './BreadCrumbComponent';

interface ICategoryHeaderProps {
  breadCrumb?: IBreadcrumbSection;
  cancelView: () => void;
  editDataView: boolean;
  handleSave: () => void;
  isCategoryDataModified: boolean;
  navigateToCategory: (section: ISection) => void;
  onAddRootSection: () => void;
  onEnableEditView: () => void;
  t: TFunction;
}

export const CategoryHeader: React.FC<ICategoryHeaderProps> = ({
  breadCrumb,
  cancelView,
  editDataView,
  handleSave,
  isCategoryDataModified,
  navigateToCategory,
  onAddRootSection,
  onEnableEditView,
  t,
}) => (
  <div className="header-section">
    <div className="section-view">
      <h4>{t('labels.categories')}</h4>
      <div className="edit-view">
        <div className="icon-with-label">
          <IconType
            type="cancel"
            onClick={cancelView}
            aria-label="Cancel View"
            style={{
              color: '#1474a4',
              cursor: editDataView ? 'pointer' : 'not-allowed',
              marginRight: 12,
              opacity: editDataView ? 1 : 0.5,
            }}
            disabled={!editDataView}
            fontSize="large"
            className="header-large-icon"
          />
          <div className="icon-helper-text">Cancel</div>
        </div>
        <div className="icon-with-label">
          <IconType
            type="save"
            onClick={handleSave}
            aria-label="Save View"
            style={{
              color: '#1474a4',
              cursor: editDataView && isCategoryDataModified ? 'pointer' : 'not-allowed',
              marginRight: 12,
              opacity: editDataView && isCategoryDataModified ? 1 : 0.5,
            }}
            disabled={!editDataView || !isCategoryDataModified}
            fontSize="large"
            className="header-large-icon"
          />
          <div className="icon-helper-text">Save</div>
        </div>
        {!editDataView && (
          <div className="icon-with-label">
            <IconType
              type="edit"
              onClick={onEnableEditView}
              aria-label="Edit View"
              style={{ color: '#1474a4', cursor: 'pointer', opacity: 1 }}
              fontSize="large"
              className="header-large-icon"
            />
            <div className="icon-helper-text">Edit</div>
          </div>
        )}
      </div>
    </div>
    <div className="category-header-section">
      <div className="breacrum-header-section">
        <Button
          variant="contained"
          disabled={!editDataView}
          endIcon={<AddIcon />}
          onClick={onAddRootSection}
          aria-label="Add category"
        >
          {t('button.add')}
        </Button>
        {breadCrumb && (
          <BreadCrumbComponent breadcrumb={breadCrumb} navigateToCategory={navigateToCategory} />
        )}
      </div>
    </div>
  </div>
);
